import { styled } from '@linaria/react';
import { primitives, space } from '../../theme/tokens';

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['space-200']};

  > button {
    width: ${primitives.size['size-1400']};
  }
`;
